import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=9f02ce06&scoped=true&"
import script from "./blocks.vue?vue&type=script&lang=js&"
export * from "./blocks.vue?vue&type=script&lang=js&"
import style0 from "./blocks.vue?vue&type=style&index=0&id=9f02ce06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f02ce06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f02ce06')) {
      api.createRecord('9f02ce06', component.options)
    } else {
      api.reload('9f02ce06', component.options)
    }
    module.hot.accept("./blocks.vue?vue&type=template&id=9f02ce06&scoped=true&", function () {
      api.rerender('9f02ce06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/blocks.vue"
export default component.exports